import React, { FC } from 'react';
import classNames from 'classnames';
import classes from './styles/index.module.scss';
import { BaseButtonInnerProps } from './types';

export const BaseButtonInner: FC<React.PropsWithChildren<BaseButtonInnerProps>> = ({
	buttonInnerClassName,
	disabled,
	children,
	iconClassName,
	startIcon,
	endIcon,
}) => {
	const buttonInnerClassNames = classNames(classes.inner, buttonInnerClassName, {
		[classes.inner_disabled]: disabled,
	});

	const startIconClassNames = classNames(classes.icon, classes.startIcon, iconClassName);

	const endIconClassNames = classNames(classes.icon, classes.endIcon, iconClassName);

	return (
		<span className={buttonInnerClassNames}>
			{startIcon && <span className={startIconClassNames}>{startIcon}</span>}
			{children}
			{endIcon && <span className={endIconClassNames}>{endIcon}</span>}
		</span>
	);
};

export default BaseButtonInner;
